export default "__VITE_ASSET__C$03T$dF__"